import LTR from "../../../icons/ploom/tools-no_tool/tools-no_tool-ltr.svg";
import { iconFactory } from "../iconFactory";
export const ToolsNoToolIcon = iconFactory("ToolsNoToolIcon", LTR);
//# sourceMappingURL=tools-no_tool.js.map